import { BlockBaseProps } from "@store/Components/Common/Block/Block";
import { defaultBorderProps } from "@store/Components/Common/Block/defaultProps";
import { BlockVariant, variants } from "@store/Components/Common/Block/variant/config";
import { css } from "styled-components";

export const getVariantBorderProps = (props: any) => {
    return {
        width: props?.border?.width ?? defaultBorderProps.width,
        type: props?.border?.type ?? defaultBorderProps.type,
        color: props?.border?.color ?? defaultBorderProps.color,
    };
};

export const getVariantCss = (property: string) => {
    return ({ variant, variantProps }: BlockBaseProps) => {
        if (variantProps) {
            for (const [key, value] of Object.entries(BlockVariant)) {
                if (variant === value) {
                    const _key = key.toLowerCase();
                    const staticProps = variants[_key]?.staticProps ?? {};
                    const currentProps = (variantProps as any)[_key] ?? {};

                    return css`
                        ${staticProps[property]}
                        ${currentProps[property]}
                    `;
                }
            }
        }

        return null;
    };
};
